var _rect, _rect2, _rect3, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRestart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 52,
    fill: "none",
    viewBox: "0 0 67 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21_19)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 47.84,
    x: 0.25,
    y: 4,
    fill: "#EA9975",
    rx: 20
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 46,
    x: 0.25,
    fill: "#FBC399",
    rx: 20
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21_19",
    width: 67,
    height: 46,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 46,
    x: 0.25,
    fill: "#fff",
    rx: 20
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B67C62",
    d: "M43.9806 23.1303C43.658 17.6045 39.2456 13.0916 33.8119 12.6813V9.56382C33.8119 9.09906 33.2739 8.82555 32.924 9.12576L26.6833 14.1589C26.4143 14.378 26.4143 14.8149 26.6833 15.0339L32.924 20.0395C33.2739 20.3408 33.8119 20.0673 33.8119 19.6014V16.5928C37.6315 17.0309 40.5371 20.5587 40.1061 24.6335C39.7572 27.9712 37.0935 30.6787 33.8119 31.0342C29.7233 31.499 26.1987 28.4359 25.8488 24.4421C25.8214 24.0863 25.5262 23.8128 25.1762 23.8128H22.6743C22.2708 23.8128 21.9744 24.1408 22.0017 24.551C22.4063 30.3782 27.1675 35 33.0047 35C39.2728 35 44.3565 29.6121 43.9804 23.1301L43.9806 23.1303Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_19"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 52,
    fill: "#fff",
    transform: "translate(0.25)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestart);
export default __webpack_public_path__ + "static/media/restart.e88f3bc479aeeea394e02a6e560a088c.svg";
export { ForwardRef as ReactComponent };